




































































import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import FoldingCard from '@/components/FoldingCard.vue'
import { dateTimeToDisplay } from '@/utils/dateTime'
import { Contact } from '@/modules/Contact/interfaces/contact'

import QuoteDialog from '@/modules/Quote/scripts/quote-dialog'

import { quoteStatusClass, quoteStatus, quoteType } from '@/modules/Quote/helpers/quote'

@Component({
  components: {
    FoldingCard
  }
})
export default class ContactDetailQuotes extends mixins(QuoteDialog) {
  @Prop({ type: Object as () => Contact }) readonly contact!: Contact

  accountId: number | null = null

  quoteStatusClass = quoteStatusClass
  quoteStatus = quoteStatus
  quoteType = quoteType

  tableColumn = [
    { field: 'name',
      title: 'Quote Name',
      slots: { default: 'name_default' },
      resizable: true
    },
    { field: 'accountName',
      title: 'Account Name',
      slots: { default: 'account_name_default' },
      resizable: true
    },
    { field: 'contactName',
      title: 'Contact Name',
      slots: { default: 'contact_name_default' },
      resizable: true
    },
    { field: 'status', title: 'Quote Status', slots: { default: 'status_default' }, resizable: true, width: 140 },
    { field: 'type', title: 'Quote Type', slots: { default: 'type_default' }, resizable: true, width: 140 },
    { field: 'createdAt',
      title: 'Creation Time',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.createdAt ? dateTimeToDisplay(row.createdAt) : '-')
        ]
      }
      },
      resizable: true,
      width: 190
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  @Emit('refresh')
  onSuccess () {
    // do nothing
  }

  dateTimeToDisplay = dateTimeToDisplay

  get QuotesList () {
    return this.contact.quotes || []
  }

  routeToQuoteDetail (item: any) {
    this.$router.push({
      name: 'QuoteDetailDetail',
      params: {
        id: item.id
      }
    })
  }

  routeToAllList () {
    this.$router.push({
      name: 'ContactRelatedQuotesList',
      params: {
        id: this.contact.id + ''
      }
    })
  }

  routeToAccountDetail (item: any) {
    if (!item.account) {
      return
    }
    this.$router.push({
      name: 'AccountDetailDetail',
      params: {
        id: item.account.id
      }
    })
  }

  routeToContactDetail (item: any) {
    if (!item.primaryContact) {
      return
    }
    this.$router.push({
      name: 'ContactDetailDetail',
      params: {
        id: item.primaryContact.id
      }
    })
  }

  async deleteQuoteConfirm () {
    await this.deleteQuotePost()
    this.onSuccess()
  }
}
